
export function formatPersonalSecurityNumberAndOrganisationNumber(value: string | undefined): string {
    if (value === undefined) {
        return "";
    }
    if (value.length <= 4) {
        return value;
    }
    const valueWithNoHyphen = value.replace("-", "");
    const reversedValue = valueWithNoHyphen.split('').reverse().join('');
    const reversedValueWithHyphen = `${reversedValue.slice(0, 4)}-${reversedValue.slice(4, reversedValue.length)}`;

    return reversedValueWithHyphen.split('').reverse().join('');
}